import AbstractUserService from './AbstractUserService';

export default class CookieBasedAuthUserService
    extends AbstractUserService {
}
